// extracted by mini-css-extract-plugin
export default {"productDescription":"Eaa-z","featuredDescription":"Faa-z","description":"Gaa-z","more":"Haa-z","descriptionSku":"Iaa-z"};